import { useState } from "react";
import { PopUp, Slider, Button, Box } from "../..";
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { useApp } from '../../../../contexts';
import { translateText } from '../../../../helpers/util';

export const PopUpComparativeUniverseIndustrial = ({ handleComparativeUniverse, triggerClose }) => {
    const { language, translations, userCountry } = useApp()
    const [form, setForm] = useState({
        classes: [],
        type: [],
        typeRegion: "region",
        radius: 0
    });

    const classes = [
        [
            {label: "AAA", value: "AAA"},
            {label: "AA", value: "AA"},
            {label: "A", value: "A"}
        ],
        [
            {label: "B", value: "B"},
            {label: "C", value: "C"}
        ]
    ];
    
    const type = [
        [
            {label: translateText("Condomínio", language, translations, userCountry), value: "Condomínio"},
            {label: translateText("Galpão", language, translations, userCountry), value: "Galpão"}
        ]
    ];


    const handleCheck = (event) => {
        const el = event.target
        let array = [...form[el.name]]
        
        if(el.checked){
            array.push(el.value)
        }else{
            array = array.filter((value) => {
                return value != el.value
            });
        }
        let values = {
            ...form
        }
        values[el.name] = array;
        setForm(values);
    }
    
    const handleRadio = (event) => {
        const newValue = event.target.value
        setForm({ 
            ...form,
            typeRegion: newValue,
            radius: newValue == 'region' ? 0 : form.radius
        });
    };

    const handleSlider = (event, newValue) => {
        setForm({
            ...form,
            radius: newValue
        })
    }

    const handleButton = () => {
        handleComparativeUniverse(form);
    }

    return (
        <PopUp buttonFooter={true} onClose={handleButton} text={translateText("Universo Comparativo", language, translations, userCountry)}>
            <CheckBoxGroup data={classes} title={translateText("Classes", language, translations, userCountry)} name="classes" callback={handleCheck} />
            <CheckBoxGroup data={type} title={translateText("Tipo", language, translations, userCountry)} name="type" callback={handleCheck} />
            <FormControl sx={{ marginTop: 2 }}>
                <FormLabel sx={{ fontWeight: "bold", color: "black" }}>{translateText("Localização", language, translations, userCountry)}</FormLabel>
                <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue="region"
                    name="radio-buttons-group"
                    onChange={handleRadio}
                >
                    <FormControlLabel value="region" control={<Radio />} label={translateText("Região", language, translations, userCountry)} />
                    <FormControlLabel value="radius" control={<Radio />} label={`${translateText("Raio", language, translations, userCountry)}${form.typeRegion == "radius" ? ": "+form.radius+"m" : ''}`} />
                </RadioGroup>
                { form.typeRegion == "radius" && 
                    <Slider defaultValue={0} step={100} max={1500} onChange={handleSlider} valueLabelDisplay="off"/>
                }
            </FormControl>
        </PopUp>
    )
}

const CheckBoxGroup = ({ data, title, name, callback }) => {
    return (
        <FormControl>
            <FormLabel sx={{ fontWeight: "bold", color: "black" }}>{title}</FormLabel>
            {data.map((row, key) => {
                return (
                    <FormGroup key={`row-${key}`} aria-label="position" row>
                        {row.map((item, index) => {
                            return (
                                <FormControlLabel
                                key={`class-${item.value}-${index}`}
                                value={item.value}
                                control={<Checkbox name={name} onChange={callback} />}
                                label={item.label}
                                labelPlacement="end"
                                />
                            )
                        })}
                    </FormGroup>
                )
            })}
        </FormControl>  
    );
}